import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const TextArea = (props) => {
  const inputRef = useRef(null);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (props.value) {
      setCounter(props.value.length);
    }
  }, [props.value]);

  const onTextAreaChange = (e) => {
    props.onChange(e);
    setCounter(e.target.value.length);
  };

  return (
    <>
      <textarea
        id={props.id}
        ref={inputRef}
        data-testid={props.id}
        className={`textarea ${props.className}`}
        placeholder={
          props.intl.messages[props.placeholder] || props.placeholder
        }
        onChange={onTextAreaChange}
        value={props.intl.messages[props.value] || props.value}
        maxLength={props.limit}
        disabled={props.disabled}
      />
      {props.limit && (
        <div
          data-testid={`${props.id}-limit-counter`}
          className='text-paragraph --small text-align-right limit-counter italic'
        >
          ({counter}/{props.limit})
        </div>
      )}
    </>
  );
};

TextArea.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(TextArea);
